import { render } from "./educacaoInfantil.vue?vue&type=template&id=14cefaf5&scoped=true"
import script from "./educacaoInfantil.vue?vue&type=script&lang=js"
export * from "./educacaoInfantil.vue?vue&type=script&lang=js"

import "./educacaoInfantil.vue?vue&type=style&index=0&id=14cefaf5&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14cefaf5"]])

export default __exports__